import { render } from "./InviteUserForm.vue?vue&type=template&id=5d5637fe&ts=true"
import script from "./InviteUserForm.vue?vue&type=script&lang=ts"
export * from "./InviteUserForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/InviteUserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d5637fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d5637fe', __exports__)) {
    api.reload('5d5637fe', __exports__)
  }
  
  module.hot.accept("./InviteUserForm.vue?vue&type=template&id=5d5637fe&ts=true", () => {
    api.rerender('5d5637fe', render)
  })

}


export default __exports__